import type { Method } from 'lib/axios';
import { APICallV2Post, APICallV4 } from 'reactApp/api/APICall';
import { apiMigrateWeblinksV2ToV4 } from 'reactApp/appHelpers/featuresHelpers';

const method = 'weblinks/editable';

class WeblinksEditableOffAPIV2Call extends APICallV2Post {
    _method = `${method}/off`;
}

class WeblinksEditableOffAPIV4Call extends APICallV4 {
    _method = method;
    _type: Method = 'post';
}

export const weblinksEditableOffApiCall = (params: Record<string, any>): Promise<unknown> => {
    if (apiMigrateWeblinksV2ToV4.editable) {
        return new WeblinksEditableOffAPIV4Call().makeRequest({
            weblink_id: params.weblink,
            enable: false,
        });
    }

    return new WeblinksEditableOffAPIV2Call().makeRequest(params);
};
